export default [
    {
        path: '/publicPage/prioritySettlement',
        name: 'prioritySettlement',
        component: () => import( './prioritySettlement.vue'),
        meta: {
            authPass: true,
            title: '优先结算运单管理',
            headerId: 'myFortune'
        }
    }
];
